module.exports = __webpack_public_path__ + "static/media/profile 1.709b0551.png";